import React, { useEffect, useState } from 'react'
import ViewTableIndex from '../../../components/View/ViewTableIndex'
import { useStandard } from '../../../context/StandardContext';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../services/axiosComman';
import { PaperClip } from '../../../assets/icons';
import { TableLoader } from '../../../components/Loader';
import UseGetData from '../../../hooks/useFetchData';
import NuDateFormat from '../../../utils/NuDate';
import CreateOrEdit from './form';
import ViewMore from './viewMore';

function VendorManagementIndex() {
    const { standardName } = useStandard();
    const {stdId} = useParams()
    const [showMyModal, setShowMyModal] = useState(false);
    const handleOnClose = () => setShowMyModal(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [dataCount, setDataCount] = useState(20);
    const [listOfVendors,setListOfVendors] = useState([]);
    const {data, totalCount,getData,isLoading} = UseGetData({url:`/ConnectVendor/standard/${stdId}/`,page:pageIndex,pageCount:dataCount})
    

    const VendorList = async () => {
        await axiosInstance.get("/Vendor-Management/get").then((res) => {
          let data = res?.data?.data;
          let xyz = [];
          data.forEach((i) => {
            let x = { label: i?.vendor_name, value: i?.id };
            xyz.push(x);
          });
          res?.data && setListOfVendors(xyz);
        });
      };
    
      useEffect(() => {
        VendorList();
      }, []);

  return (
    <>
        <ViewTableIndex
    label='Vendor Management'
    menu="Information"
    information='This page has information related to Vendors including Non-Disclosure Agreements and Service Level Agreements.'
    standardName={standardName}
    total={totalCount} 
    setDataCount={setDataCount} 
    dataCount={dataCount} 
    pageIndex={pageIndex} 
    setPageIndex={setPageIndex}  
    setOpenForm={setShowMyModal}
    Access="information_create"
    header={header}
    isLoading={isLoading}
    >
                        <>
                  {data &&
                    data.map((data, i) => (
                      <tr
                        className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                        key={i}
                      >
                        <td
                          className={`text-center text-gray-900 py-1.5 w-[10%]`}
                        >
                          {data.serial_number || "#"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1.5 w-[27%]`}
                        >
                          {data?.vendorDetails?.vendor_name || "-"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1.5 w-[20%]`}
                        >
                          {data?.vendorDetails?.vendor_type || "-"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1.5 w-[30%] flex justify-center items-center`}
                        >
                          {(data?.attachments.length > 0) && <PaperClip />}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1.5 w-[10%] flex justify-center items-center`}
                        >
                            {(data?.on_board_date !== "None" &&
                              data?.on_board_date !== "" &&
                              NuDateFormat({
                                value: data?.on_board_date,
                                format: "DD-MMM-yyyy",
                              })) ||
                              "-"}
                        </td>
                        <td className={`text-center text-gray-900 py-1.5 w-[3%]`}>
                          <div className=" w-full h-full flex justify-center items-center">
                            <ViewMore
                              data={data}
                              fetcher={getData}
                              vendorList={listOfVendors}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
    </ViewTableIndex>
    
    <CreateOrEdit
          onClose={handleOnClose}
          visible={showMyModal}
          refreshData={getData}
          vendorList={listOfVendors}
          id={stdId}
        />
    </>
  )
}

export default VendorManagementIndex

const header = [
    {
      headone: "Sl No.",
      width: "w-[10%]",
    },
    {
      headone: "Vendor Name",
      width: "w-[27%]",
    },
    {
      headone: "Vendor Type",
      width: "w-[20%]",
    },
    {
      headone: "Documents Type - NDA, SLA, Contract",
      width: "w-[30%]",
    },
    {
      headone: "OnBoard Date",
      width: "w-[10%]",
    },
    {
      headone: "",
      width: "w-[3%]",
    },
  ];